export default __webpack_public_path__ + "static/3-0853b094dbbc1bbc31fabb8481ceacf8.png";